module.exports = __webpack_public_path__ + "img/kv_2_2.516688a6.png";